import { Component, type ErrorInfo, type ReactNode } from 'react';

/**
 * Keeps a guide's failure a guide's failure: the engine is wrapped in this, so
 * an error in it ends the guide (and its clean-up runs) instead of taking the
 * page down. It does not swallow anything else — only the engine is inside.
 */
export class GuidanceErrorBoundary extends Component<
  { children: ReactNode; onError: () => void },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Guided tour stopped after an error', error, info.componentStack);
    this.props.onError();
  }

  render(): ReactNode {
    return this.state.failed ? null : this.props.children;
  }
}
